import {observer} from "mobx-react";
import {
    ContentExportImport, ContentFilter, ContentFilterNewTicket,
    ContentInput,
    ContentInputAndListableTicketsDeleted,
} from "./styled";
import {useBetween} from "use-between";
import {useModalTickets} from "@dropDesk/presentation/pages/ticket/ui/search/modals/visible_modal_search";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import React from "react";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {PeriodEnum} from "@dropDesk/utils/helpers/common";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";
import FiltersNotFixed from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/filters_not_fixed";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import ButtonNewTicket from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/button_new_ticket";

const SearchBarTickets = observer(
    ({
         onSearch,
         filterStatus,
         filterPriority,
         setFilterStatus,
         setFilterPriority,
         visibleInputSearch,
         visibleButtonsOfActions,
         visibleButtonDeleted,
         visibleButtonRestore,
         loading,
         setListOnlySectorEmpty,
         listOnlySectorEmpty,
         setFilterAttendant,
         filterAttendant,
         setFilterUserClient,
         filterUserClient,
         setFilterSector,
         filterSector,
         filterDescriptionStatic,
         setFilterDescriptionStatic,
         filterClient,
         setFilterClient,
         period,
         labelPeriod,
         setFilterPeriod,
         visiblePopupButtonFilter,
         setVisiblePopupButtonFilter,
         removeAllFilters
     }: {
        onSearch: (searchParam?: string) => void,
        setFilterStatus: (filter: TicketConfig | null, withList?: boolean) => void,
        setFilterPriority: (filter: TicketConfig | null, withList?: boolean) => void,
        setFilterAttendant: (filter: UserEntity | null, withList?: boolean) => void,
        setFilterUserClient: (filter: UserEntity | null, withList?: boolean) => void,
        setFilterSector: (filter: SectorEntity | null, withList?: boolean) => void,
        setFilterDescriptionStatic: (filter: TicketsDescriptionStaticEntity | null, withList?: boolean) => void,
        setFilterClient: (filter: ClientEntity | null, withList?: boolean) => void,
        setListOnlySectorEmpty: (value: boolean, withList?: boolean) => void,
        setFilterPeriod: (period: Array<Date> | null, label: PeriodEnum | null, withList?: boolean) => void
        filterStatus: TicketConfig | null,
        filterPriority: TicketConfig | null,
        visibleInputSearch: boolean,
        visibleButtonsOfActions: boolean,
        visibleButtonDeleted: boolean,
        visibleButtonRestore: boolean,
        loading: boolean
        listOnlySectorEmpty: boolean
        filterAttendant: UserEntity | null
        filterUserClient: UserEntity | null
        filterSector: SectorEntity | null
        filterDescriptionStatic: TicketsDescriptionStaticEntity | null
        filterClient: ClientEntity | null
        period: Array<Date> | null
        labelPeriod: PeriodEnum | null
        visiblePopupButtonFilter: boolean
        setVisiblePopupButtonFilter: React.Dispatch<React.SetStateAction<boolean>>
        removeAllFilters: () => void
    }) => {
        const {setVisibleModalRestore, setVisibleModalDelete} = useBetween(useModalTickets);

        return (
            <ContentFilter>
                <ContentFilterNewTicket>
                    <ContentInputAndListableTicketsDeleted>
                        <ContentInput>
                            {visibleInputSearch &&
                                <FiltersNotFixed
                                    onSearch={onSearch}
                                    filterStatus={filterStatus}
                                    filterPriority={filterPriority}
                                    setFilterStatus={setFilterStatus}
                                    setFilterPriority={setFilterPriority}
                                    loading={loading}
                                    setListOnlySectorEmpty={setListOnlySectorEmpty}
                                    listOnlySectorEmpty={listOnlySectorEmpty}
                                    setFilterAttendant={setFilterAttendant}
                                    filterAttendant={filterAttendant}
                                    setFilterUserClient={setFilterUserClient}
                                    filterUserClient={filterUserClient}
                                    setFilterSector={setFilterSector}
                                    filterSector={filterSector}
                                    filterDescriptionStatic={filterDescriptionStatic}
                                    setFilterDescriptionStatic={setFilterDescriptionStatic}
                                    filterClient={filterClient}
                                    setFilterClient={setFilterClient}
                                    period={period}
                                    labelPeriod={labelPeriod}
                                    setFilterPeriod={setFilterPeriod}
                                    visiblePopupButtonFilter={visiblePopupButtonFilter}
                                    setVisiblePopupButtonFilter={setVisiblePopupButtonFilter}
                                />
                            }
                            {visibleButtonDeleted && <ButtonNew
                                marginLeft={0}
                                label={'Excluir'}
                                onClick={() => setVisibleModalDelete(true)}
                                nameLeftIcon={ICONS_DROPDESK.delete}
                                sizeLeftIcon={16}
                                disabled={loading}
                            />}
                            {visibleButtonRestore && <ButtonNew
                                marginLeft={0}
                                label={'Restaurar'}
                                onClick={() => setVisibleModalRestore(true)}
                                nameLeftIcon={ICONS_DROPDESK.restore}
                                sizeLeftIcon={16}
                                disabled={loading}
                            />}

                        </ContentInput>

                    </ContentInputAndListableTicketsDeleted>
                    <ContentExportImport>
                        {visibleButtonsOfActions && <ButtonNewTicket/>}
                    </ContentExportImport>
                </ContentFilterNewTicket>
            </ContentFilter>
        )
    })
export default SearchBarTickets;
